export const ACTIVITIES_UNREAD_CHANGED = 'activities-unread-changed';

export const notifyActivitiesUnreadChanged = (totalUnread) => {
    if (typeof window === 'undefined') {
        return;
    }
    const detail = {};
    if (typeof totalUnread === 'number' && Number.isFinite(totalUnread)) {
        detail.totalUnread = Math.max(0, Math.floor(totalUnread));
    }
    window.dispatchEvent(new CustomEvent(ACTIVITIES_UNREAD_CHANGED, { detail }));
};
